<template>
  <div style="width: 100%">
    <div>
      <div class="page flex-col">
        <div class="section_1 flex-col justify-end">
          <div class="box_1 flex-col">
            <div class="box_2 flex-row">
              <div class="flex-row" style="align-items: center">
                <img
                  @click="toPath('/index')"
                  data-track-text="首页Logo"
                  aria-label="首页Logo"
                  class="image_1"
                  referrerpolicy="no-referrer"
                  src="../assets/v2/img/logo.png"
                />
                <span class="text_1" style="width: auto">
                  <span v-if="false">
                    <el-dropdown @command="gotoPage">
                      <span> 产品 </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          command="text"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 文本翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="doc"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 文档翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="ai"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> AI翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="lange"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 多语种翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="polish"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 润色改写 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="aiPPT"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> AI PPT </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="rag"
                          style="z-index: 1; font-weight: 800; position: relative;"
                        >
                          <span> RAG知识库 </span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/index/operate.png"
                    />
                  </span>
                  <span v-if="false" style="margin-left: 30px; width: auto">
                    <el-dropdown @command="logOut">
                      <span> 服务 </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          command="toTransPro"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 人工翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="standLangSet"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 术语词库 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="convertDoc"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 文档转换 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="mySelfDoc"
                          style="z-index: 1; font-weight: 800"
                        >
                          <span> 我的文档 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="webTranslate"
                          style="z-index: 1; font-weight: 800; position: relative;"
                        >
                          <span> 网页翻译 </span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="smartClassify"
                          style="z-index: 1; font-weight: 800; position: relative;"
                        >
                          <span> 数据分析 </span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/index/operate.png"
                    />
                  </span>
                  <span
                    style="margin-left: 30px; width: auto"
                    data-track-text="首页导航文本翻译"
                    aria-label="首页导航文本翻译"
                    @click="gotoPage('text')"
                  >
                    文本翻译
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航文档翻译"
                    aria-label="首页导航文档翻译"
                    @click="gotoPage('doc')"
                  >
                    文档翻译
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航AI翻译"
                    aria-label="首页导航AI翻译"
                    @click="gotoPage('ai')"
                  >
                    AI翻译
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航润色改写"
                    aria-label="首页导航润色改写"
                    @click="gotoPage('polish')"
                  >
                    润色改写
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航AI PPT"
                    aria-label="首页导航AI PPT"
                    @click="gotoPage('aiPPT')"
                  >
                    AI PPT
                  </span>
                  <span
                    style="margin-left: 22px; width: auto; position: relative;"
                    data-track-text="首页导航RAG知识库"
                    aria-label="首页导航RAG知识库"
                    @click="gotoPage('rag')"
                  >
                    RAG知识库
                    <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: -8px;right: -20px;width: 18px;height: auto;"/>
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航人工翻译"
                    aria-label="首页导航人工翻译"
                    @click="logOut('toTransPro')"
                  >
                    人工翻译
                  </span>
                  <span
                    style="margin-left: 22px; width: auto"
                    data-track-text="首页导航我的文档"
                    aria-label="首页导航我的文档"
                    @click="logOut('mySelfDoc')"
                  >
                    我的文档
                  </span>
                  <span
                    style="margin-left: 22px; width: auto; position: relative;"
                    data-track-text="首页导航网页翻译"
                    aria-label="首页导航网页翻译"
                    @click="logOut('webTranslate')"
                  >
                    网页翻译
                    <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: -8px;right: -20px;width: 18px;height: auto;"/>
                  </span>
                  <span
                    style="margin-left: 22px; width: auto; position: relative;"
                    data-track-text="首页导航数据分析"
                    aria-label="首页导航数据分析"
                    @click="logOut('smartClassify')"
                  >
                    数据分析
                    <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: -8px;right: -20px;width: 18px;height: auto;"/>
                  </span>
                  <span class="nav-more">
                    更多
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/index/operate.png"
                    />
                    <div class="nav-more-menu">
                      <div class="nav-more-item">
                        <span>产品</span>
                        <i class="el-icon-arrow-right"></i>
                        <div class="nav-more-sub">
                          <div data-track-text="更多菜单文本翻译" aria-label="更多菜单文本翻译" @click.stop="gotoPage('text')">文本翻译</div>
                          <div data-track-text="更多菜单文档翻译" aria-label="更多菜单文档翻译" @click.stop="gotoPage('doc')">文档翻译</div>
                          <div data-track-text="更多菜单AI翻译" aria-label="更多菜单AI翻译" @click.stop="gotoPage('ai')">AI翻译</div>
                          <div data-track-text="更多菜单多语种翻译" aria-label="更多菜单多语种翻译" @click.stop="gotoPage('lange')">多语种翻译</div>
                          <div data-track-text="更多菜单润色改写" aria-label="更多菜单润色改写" @click.stop="gotoPage('polish')">润色改写</div>
                          <div data-track-text="更多菜单AI PPT" aria-label="更多菜单AI PPT" @click.stop="gotoPage('aiPPT')">AI PPT</div>
                          <div data-track-text="更多菜单RAG知识库" aria-label="更多菜单RAG知识库" @click.stop="gotoPage('rag')">RAG知识库</div>
                        </div>
                      </div>
                      <div class="nav-more-item">
                        <span>服务</span>
                        <i class="el-icon-arrow-right"></i>
                        <div class="nav-more-sub">
                          <div data-track-text="更多菜单人工翻译" aria-label="更多菜单人工翻译" @click.stop="logOut('toTransPro')">人工翻译</div>
                          <div data-track-text="更多菜单术语词库" aria-label="更多菜单术语词库" @click.stop="logOut('standLangSet')">术语词库</div>
                          <div data-track-text="更多菜单文档转换" aria-label="更多菜单文档转换" @click.stop="logOut('convertDoc')">文档转换</div>
                          <div data-track-text="更多菜单我的文档" aria-label="更多菜单我的文档" @click.stop="logOut('mySelfDoc')">我的文档</div>
                          <div data-track-text="更多菜单网页翻译" aria-label="更多菜单网页翻译" @click.stop="logOut('webTranslate')">网页翻译</div>
                          <div data-track-text="更多菜单数据分析" aria-label="更多菜单数据分析" @click.stop="logOut('smartClassify')">数据分析</div>
                        </div>
                      </div>
                    </div>
                  </span>
                </span>
              </div>
              <div class="flex-row" style="align-items: center">
                <img
                  class="thumbnail_1"
                  @click="userInfo !== '' ? toCenter : ''"
                  data-track-text="帮助"
                  aria-label="帮助"
                  referrerpolicy="no-referrer"
                  src="../assets/v2/img/index/help.png"
                />
                <span class="text_2" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">帮助</span>
                <span
                  class="text_2"
                  v-if="groupUserInfo === '机构登录'"
                  data-track-text="机构登录"
                  aria-label="机构登录"
                  @click="showIframe('/login')"
                >
                  {{ groupUserInfo }}
                </span>
                <el-dropdown
                  @command="logOut"
                  v-if="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
                  style="
                    display: flex;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                >
                  <span
                    v-show="
                      groupUserInfo !== '' && groupUserInfo !== '机构登录'
                    "
                    class="text_2"
                    >{{ groupUserInfo }}</span
                  >
                  <el-dropdown-menu
                    v-if="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
                    slot="dropdown"
                  >
                    <el-dropdown-item
                      v-for="(item, index) in groupUserInfos"
                      :key="index"
                      :command="item.name"
                      style="z-index: 1; font-weight: 800"
                    >
                      <span
                        style="
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #333333;
                        "
                        >{{ item.name }}</span
                      >
                      <span
                        style="
                          margin-left: 10px;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #333333;
                        "
                        v-if="!item.isIpScore"
                        >退出</span
                      >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <img
                  class="thumbnail_1"
                  @click="userInfo !== '' ? toCenter : ''"
                  data-track-text="个人中心"
                  aria-label="个人中心"
                  referrerpolicy="no-referrer"
                  src="../assets/v2/img/index/login.png"
                />
                <el-dropdown
                  @command="logOut"
                  v-if="showloginOut"
                  style="
                    display: flex;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                >
                  <span v-show="userInfo !== ''" class="text_2">
                    {{ userInfo }}
                  </span>
                  <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                    <el-dropdown-item
                      command="toCenter"
                      style="z-index: 1; font-weight: 800"
                    >
                      <span
                        style="
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #333333;
                        "
                        >个人中心</span
                      >
                    </el-dropdown-item>
                    <el-dropdown-item style="z-index: 1; font-weight: 800">
                      <span
                        style="
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #333333;
                        "
                        >退出</span
                      >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <span class="text_2" v-show="userInfo === ''">
                  <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
                  &nbsp;&nbsp;
                  <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
                </span>
                <span v-if="isShowInRoaming && showRoaming">
                  <span class="text_2">｜</span>
                  <el-popover
                    @hide="removeQrcode"
                    @show="getQrcode"
                    placement="top-start"
                    title="扫一扫开通漫游"
                    width="150"
                    trigger="hover"
                  >
                    <el-image
                      :src="qrcodeUrl"
                      fit="contain"
                      style="width: 150px; height: 150px"
                      alt="开通漫游"
                    >
                    </el-image>
                    <el-button
                      type="text"
                      slot="reference"
                      class="text_2"
                      style="margin-top: 4px; cursor: pointer"
                      >开通漫游</el-button
                    >
                  </el-popover>
                  <span
                    style="
                      position: absolute;
                      margin-top: -8px;
                      margin-left: -20px;
                    "
                  >
                    <img src="../assets/new_icon.png" alt="" />
                  </span>
                </span>
              </div>
            </div>
            <div class="scholar-home-search">
              <div class="scholar-home-tip">
                聚合开放获取文献元数据，快速查看 DOI、作者、机构、引用、主题和 PDF 链接。
              </div>
              <el-input
                v-model="scholarKeyword"
                class="scholar-home-input"
                clearable
                placeholder="输入论文关键词、标题或 DOI"
                @keyup.enter.native="searchScholarFromHome"
              >
                <i slot="prefix" class="el-icon-search"></i>
                <el-button slot="append" data-track-text="首页文献检索" aria-label="首页文献检索" @click="searchScholarFromHome">
                  检索
                </el-button>
              </el-input>
            </div>
            <el-carousel :interval="5000" arrow="never">
              <el-carousel-item
                v-for="(item, index) in carouselList.length"
                :key="item"
              >
                <!-- <transition name="el-fade-in-linear">
                  <div
                    style="
                      width: 1200px;
                      display: flex;
                      flex-flow: column;
                      align-items: center;
                      height: 424px;
                    "
                    v-show="item === 1"
                  >
                    <img
                      style="margin-top: 168px"
                      class="image_1"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/index/banner-img1.jpg"
                    />
                    <span
                      style="
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 300;
                        color: #f9fafa;
                        margin-top: 43px;
                      "
                    >
                      中高等院校、科研院所、公共图书馆、医疗机构等用户的全文在线翻译平台
                    </span>
                  </div>
                </transition>
                <transition name="el-fade-in-linear">
                  <div
                    style="
                      width: 1200px;
                      display: flex;
                      flex-flow: column;
                      align-items: center;
                      height: 424px;
                    "
                    v-show="item === 2"
                  >
                    <div class="box_3 flex-row">
                      <img
                        class="image_1"
                        referrerpolicy="no-referrer"
                        src="../assets/v2/img/index/banner-img2.jpg"
                      />
                      <div class="block_1 flex-col">
                        <div class="block_2 flex-row justify-between">
                          <img
                            class="label_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/index/service-person-sum.png"
                          />
                          <span class="text_4">1000+</span>
                        </div>
                        <span class="text_5">服务人数</span>
                      </div>
                      <div class="block_1_1 flex-col">
                        <div class="block_2 flex-row justify-between">
                          <img
                            class="label_2"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/index/trans-page-num.png"
                          />
                          <span class="text_4">1000+</span>
                        </div>
                        <span class="text_5">翻译页数</span>
                      </div>
                    </div>
                    <div class="box_6 flex-row">
                      <div class="image-wrapper_1 flex-col justify-between">
                        <img
                          class="thumbnail_2"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/index/checksquare.png"
                        />
                        <img
                          class="thumbnail_3"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/index/checksquare.png"
                        />
                      </div>
                      <div class="text-wrapper_1 flex-col justify-between">
                        <span class="paragraph_1"
                          >支持200+语种互译，采用业界领先的神经网络机器翻译引擎，<br />译文精准地道</span
                        >
                        <span class="paragraph_2"
                          >支持多文档多线程异步解析，极大提高翻译效率，翻译质量，<br />业界遥遥领先</span
                        >
                      </div>
                      <div
                        class="section_2 flex-col justify-center align-center"
                      >
                        <div class="box_7 flex-col">
                          <div class="block_4 flex-row justify-between">
                            <img
                              class="label_3"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/index/trans-chart-num.png"
                            />
                            <span class="text_8">12574+</span>
                          </div>
                          <span class="text_9">翻译字数</span>
                        </div>
                      </div>
                      <div
                        class="section_3 flex-col justify-center align-center"
                      >
                        <div class="block_5 flex-col">
                          <div class="section_4 flex-row justify-between">
                            <img
                              class="label_4"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/index/service-group.png"
                            />
                            <span class="text_10">300+</span>
                          </div>
                          <span class="text_11">服务机构</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="box_8 flex-row"
                      data-track-text="首页立即翻译"
                      aria-label="首页立即翻译"
                      @click="toPath('/translate', 'doc')"
                    >
                      <div class="text-wrapper_2 flex-col">
                        <span class="text_12">立即翻译</span>
                      </div>
                    </div>
                  </div>
                </transition> -->
	                <img
	                  style="width: 1440px; height: 440px; object-fit: cover"
	                  data-track-text="点击首页轮播图"
	                  aria-label="点击首页轮播图"
	                  data-track-ignore
	                  @click="clickCarousel(carouselList[carouselList.length - item])"
	                  :src="carouselList[carouselList.length - item]?.pathUrl"
	                  :alt="carouselList[carouselList.length - item]?.title"
	                />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="introduce">
            <div class="container">
              <div class="title">微思翻译 无所不译</div>
              <div class="desc">
                打造专业、高效、便捷的翻译管理平台，协助用户快速完成文档翻译，
                为用户提供一站式翻译解决方案
              </div>
              <div class="introduce-container">
                <div
                  class="introduce-item"
                  v-for="item in introduceList"
                  :key="item.title"
                  :data-track-text="`体验${item.title}`"
                  :aria-label="`体验${item.title}`"
                  @click="gotoPage(item.type)"
                >
                  <div class="introduce-icon" :class="[item.icon]"></div>
                  <div class="introduce-title">{{ item.title }}</div>
                  <div class="introduce-desc">{{ item.desc }}</div>
                  <div class="goto">
                    立即体验
                    <span class="el-icon-sanjiaoright"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="advantage">
            <div class="container">
              <div class="title">产品优势</div>
              <div class="desc">想翻译，找微思翻译神器来帮忙</div>
              <div class="advantage-container">
                <div
                  class="advantage-item"
                  v-for="item in advantageList"
                  :key="item.title"
                >
                  <div class="advantage-icon" :class="[item.type]">
                    <span :class="[item.icon]"></span>
                  </div>
                  <div class="introduce-title">{{ item.title }}</div>
                  <div class="introduce-desc">{{ item.desc }}</div>
                </div>
              </div>
              <div
                class="left"
                v-if="advantageIndex != 0"
                data-track-text="上一个产品优势"
                aria-label="上一个产品优势"
                @click="changeAdvantageIndex(-2)"
              >
                <span class="el-icon-jiantou"></span>
              </div>
              <div
                class="right"
                v-if="advantageIndex <= 1"
                data-track-text="下一个产品优势"
                aria-label="下一个产品优势"
                @click="changeAdvantageIndex(2)"
              >
                <span class="el-icon-jiantou"></span>
              </div>
            </div>
          </div>
          <div class="tool">
            <div class="container">
              <div class="title">工具服务</div>
              <div class="desc">想高效，选智能服务，让文档翻译更简单</div>
              <div class="tool-container">
                <div class="tabs">
                  <div
                    class="artificiality tabs-item"
                    :class="[currentTool === 'artificiality' ? 'select' : '']"
                    data-track-text="工具服务人工翻译"
                    aria-label="工具服务人工翻译"
                    @click="selectTool('artificiality')"
                  >
                    <span class="el-icon-rengong"></span>
                    人工翻译
                  </div>
                  <div
                    class="lexicon tabs-item"
                    :class="[currentTool === 'lexicon' ? 'select' : '']"
                    data-track-text="工具服务术语词库"
                    aria-label="工具服务术语词库"
                    @click="selectTool('lexicon')"
                  >
                    <span class="el-icon-shuyuku"></span>
                    术语词库
                  </div>
                  <div
                    class="doc-convert tabs-item"
                    :class="[currentTool === 'convert' ? 'select' : '']"
                    data-track-text="工具服务文档转换"
                    aria-label="工具服务文档转换"
                    @click="selectTool('convert')"
                  >
                    <span class="el-icon-a-16Dzhuanhuan"></span>
                    文档转换
                  </div>
                  <div
                    class="document tabs-item"
                    :class="[currentTool === 'document' ? 'select' : '']"
                    data-track-text="工具服务我的文档"
                    aria-label="工具服务我的文档"
                    @click="selectTool('document')"
                  >
                    <span class="el-icon-wenben-mianxing"></span>
                    我的文档
                  </div>
                </div>
                <div class="tabs-container">
                  <div
                    class="art-container tabs-container-item"
                    v-show="currentTool === 'artificiality'"
                  >
                    <div class="left-container">
                      <div class="title">
                        汇集全球海量人才资源， 打造权威翻译团队
                      </div>
                      <div class="tabs-container-list">
                        <div class="list-item">
                          <span class="dot">•</span>
                          致力于提供精准高效的翻译服务
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          支持20多种语言翻译，多种文档格式
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          保留原文格式，提供多种类型服务
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          多年翻译经验，严格把控翻译质量
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          全天候的专家小组确保售后无忧
                        </div>
                      </div>
                      <div class="experience" data-track-text="体验人工翻译" aria-label="体验人工翻译" @click="toPath('/trans-pro')">
                        立即体验
                      </div>
                    </div>
                    <div class="right-container"></div>
                  </div>
                  <div
                    class="lexicon-container tabs-container-item"
                    v-show="currentTool === 'lexicon'"
                  >
                    <div class="left-container"></div>
                    <div class="right-container">
                      <div class="title">
                        确保多语言信息的一致性，节省时间和成本
                      </div>
                      <div class="tabs-container-list">
                        <div class="list-item">
                          <span class="dot">•</span>
                          为单词和短语的翻译设定规则
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          将术语表应用于文档翻译
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          提高译文一致性
                        </div>
                      </div>
                      <div
                        class="experience"
                        data-track-text="体验术语词库"
                        aria-label="体验术语词库"
                        @click="toPath('/translate', 'setting')"
                      >
                        立即体验
                      </div>
                    </div>
                  </div>
                  <div
                    class="convert-container tabs-container-item"
                    v-show="currentTool === 'convert'"
                  >
                    <div class="left-container">
                      <div class="title">
                        专业的在线文档转换器，多种格式的文档转换
                      </div>
                      <div class="tabs-container-list">
                        <div class="list-item">
                          <span class="dot">•</span>
                          界面简洁、一键式操作
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          提供多种格式的文档相互转换
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          具备快速转换，高保真输出
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          快速转换，性能稳定
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          强速内核转化快速，在线操作提升效率
                        </div>
                      </div>
                      <div
                        class="experience"
                        data-track-text="体验文档转换"
                        aria-label="体验文档转换"
                        @click="toPath('/translate', 'convert')"
                      >
                        立即体验
                      </div>
                    </div>
                    <div class="right-container"></div>
                  </div>
                  <div
                    class="document-container tabs-container-item"
                    v-show="currentTool === 'document'"
                  >
                    <div class="left-container"></div>
                    <div class="right-container">
                      <div class="title">支持保存文档翻译记录</div>
                      <div class="tabs-container-list">
                        <div class="list-item">
                          <span class="dot">•</span>
                          可以轻松查找到翻译历史记录
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          翻译记录省去再次翻译的时间和精力
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          可以避免重复工作，提高工作效率
                        </div>
                        <div class="list-item">
                          <span class="dot">•</span>
                          作为学习辅助资料，帮助提高翻译技能
                        </div>
                      </div>
                      <div class="experience" data-track-text="体验我的文档" aria-label="体验我的文档" @click="toPath('/list-pro')">
                        立即体验
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="partner">
            <div class="group_10 flex-col">
              <div class="text-wrapper_6 flex-row">
                <span class="text_32">合作伙伴</span>
              </div>
              <div class="partner-container">
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__石化.png"
                  />
                  <span class="name">中国石化北京化工研究院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__宣武.png"
                  />
                  <span class="name">首都医科大学宣武医院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__华北电力.png"
                  />
                  <span class="name">华北电力大学（保定）</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__农林.png"
                  />
                  <span class="name">北京市农林科学院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__辽宁.png"
                  />
                  <span class="name">辽宁省农业科学院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__河北工程.png"
                  />
                  <span class="name">河北工程技术学院</span>
                </div>
              </div>
              <div class="partner-container">
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/wd.png"
                  />
                  <span class="name">北京舞蹈学院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__宁夏.png"
                  />
                  <span class="name">宁夏农林科学院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__中国医科大学.png"
                  />
                  <span class="name">中国医科大学</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__妇幼.png"
                  />
                  <span class="name" title="北京妇产医院">北京妇产医院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__北京友谊.png"
                  />
                  <span class="name">北京友谊医院</span>
                </div>
                <div class="partner-item">
                  <img
                    class="img"
                    referrerpolicy="no-referrer"
                    src="../assets/img/p__四川大学.png"
                  />
                  <span class="name">四川大学华西医院</span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-wrapper_9 flex-col">
            <span class="paragraph_14">
              ©&nbsp;2020&nbsp;
              <span data-track-text="查看营业执照" aria-label="查看营业执照" @click="toPath('/license')" style="cursor: pointer">
                北京容智科技发展有限公司
              </span>
              &nbsp;
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="color: white"
              >
                京ICP备19036872号-3
              </a>
              &nbsp;All&nbsp;rights&nbsp;reserved.&nbsp;京公网安备&nbsp;
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010815"
                style="color: white"
                >11011402010815</a
              ><br />
              联系邮箱：
              <a
                href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询"
                style="color: white"
              >
                info&#64;wiseivy.com.cn
              </a>
              &nbsp;联系电话：010-80755328
            </span>
          </div>
        </div>
      </div>
      <div
        v-show="payCenterDialogVisible2 && activityNotice"
        style="
          z-index: 100;
          background: rgba(255, 255, 255, 0);
          box-shadow: rgba(139, 143, 148, 0) 0px 2px 2px 0px;
          position: fixed;
          right: 10px;
          top: 150px;
          left: auto;
          border-radius: 6px;
        "
      >
        <div class="left-yijian-pro">
          <div style="display: flex; justify-content: flex-end; width: 411px">
            <img
              src="../assets/close.png"
              alt="关闭"
              title="关闭"
              width="16"
              height="16"
              data-track-text="关闭首页活动浮窗"
              aria-label="关闭首页活动浮窗"
              @click="payCenterDialogVisible2Close"
            />
          </div>
          <div style="margin-left: 16px">
            <a
              v-if="activityNotice && activityNotice.linkUrl"
              :href="activityNotice.linkUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                :src="activityNotice.imageUrl"
                :alt="activityNotice.title || '活动通知'"
                :title="activityNotice.title || '活动通知'"
                width="380"
              />
            </a>
            <img
              v-else-if="activityNotice"
              :src="activityNotice.imageUrl"
              :alt="activityNotice.title || '活动通知'"
              :title="activityNotice.title || '活动通知'"
              width="380"
            />
          </div>
        </div>
      </div>
      <floating-contact-tools />
    </div>
  </div>
</template>

<script>
import { authServiceClient, translateServiceClient } from "@/tools/api/service";
import {
  outRequest,
  thirdLoginRequest,
  userPowerRequest,
  userStatusRequest,
} from "@/tools/api/auth-api";
import {
  checkRoamingRequest,
  uploadTipRequest,
  getCarouselRequest,
  getActivityNoticeRequest,
} from "@/tools/api/translate-api";
import { flush, trackElementClick } from "../utils/track";
import FloatingContactTools from "@/components/home/FloatingContactTools.vue";

export default {
  name: "NewIndex",
  components: { FloatingContactTools },
  data() {
    return {
      carouselList: [],
      activityNotice: null,
      showSelect: false,
      hasH5: false,
      hasAwarded: true,
      payCenterDialogVisible2: false,
      payCenterDialogVisible: false,
      qrcodeUrl: "",
      groupUserInfos: [],
      userInfo: "",
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      showRoaming: false,
      groupUserInfo: "",
      userId: "",
      userType: "",
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowInRoaming: false,
      isShowTransPro: false,
      timer: undefined,
      groupCheck: "toTransPro",
      scholarKeyword: "",
      introduceList: [
        {
          icon: "el-icon-wenben-mianxing",
          title: "文本翻译",
          desc: "提供世界领先的翻译能力，支持全球304种语言、近4万个翻译方向，满足跨语言交流的需求。",
          type: "text",
        },
        {
          icon: "el-icon-wendang",
          title: "文档翻译",
          desc: "支持多种格式文档，一键上传全篇翻译，高度保留样式和排版，双语对照查看，提升文档翻译效率。",
          type: "doc",
        },
        {
          icon: "el-icon-rengongzhineng",
          title: "AI翻译",
          desc: "通过人工智能技术，实现多语言之间的高效转换，提供更精准且流畅的翻译结果。",
          type: "ai",
        },
        {
          icon: "el-icon-daoyouyuzhong",
          title: "多语种翻译",
          desc: "提供多语种翻译，可以轻松地转化为目标语言，同时保留原文和译文的对应关系。",
          type: "lange",
        },
        {
          icon: "el-icon-tupian",
          title: "图片翻译",
          desc: "粘贴图片到输入框，即可快速识别图片中的文本内容，进行翻译。",
          type: "img",
        },
        {
          icon: "el-icon-rengong",
          title: "人工翻译",
          desc: "汇集全球海量人才资源，多年翻译经验，严格把控翻译质量，打造权威翻译团队。",
          type: "pro",
        },
      ],
      advantageIndex: 0,
      advantageList: [],
      oriAdvantageList: [
        {
          icon: "el-icon-lvzhou_renzhengfangshi_yijianrenzheng",
          title: "一键上传",
          desc: "一键上传，快速翻译。",
          type: "upload",
        },
        {
          icon: "el-icon-geshi_format",
          title: "多种格式",
          desc: "支持多种文档格式，doc/docx、xls/xlsx、pdf、txt、ppt/pptx。",
          type: "format",
        },
        {
          icon: "el-icon-moban",
          title: "原文排版",
          desc: "完美保留原文版式，方便对比阅读，快速对应。",
          type: "template",
        },
        {
          icon: "el-icon-piliang",
          title: "批量翻译",
          desc: "一次拖拽多篇文档同时翻译，高效、便捷。",
          type: "batch",
        },
        {
          icon: "el-icon-fanyi-full",
          title: "多种语言",
          desc: "支持304种语言的自动识别与互译服务",
          type: "lange",
        },
        {
          icon: "el-icon-dingzhijiaju",
          title: "机构定制",
          desc: "针对不同机构用户实现个性化定制需求。",
          type: "custom",
        },
      ],
      currentTool: "artificiality",
    };
  },
  watch: {
    payCenterDialogVisible(val) {
      if (val) {
        this.timer = setTimeout(this.payCenterDialogVisibleClose, 5000);
      }
    },
  },
  created() {
    this.getCarousel();
    this.showTip();
    this.getActivityNotice();
    this.getUploadTip();
    window.addEventListener("message", (e) => {
      if (e.data.data === "params") {
        if (this.hasH5) {
          this.$router.push("/h5/login");
          return;
        }
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
      }
      if (e.data.data === "register") {
        this.openTry();
      }
      if (e.data.data === "close") {
        layer.closeAll();
      }
      if (e.data.data === "topHidden") {
        this.showHeader = false;
      }
      if (e.data.data === "topNotHidden") {
        this.showHeader = true;
      }
    });
    const TOKEN_KEY = "token";
    authServiceClient
      .getUserStatus(userStatusRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
      .then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.userInfo = "";
          this.groupUserInfo = "";
          this.showRoaming = false;
          return;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          return;
        }
        const userJson = JSON.parse(user);
        const Base64 = require("js-base64").Base64;
        userJson.forEach((item) => {
          if (item.type === "Person" || item.type === "Child") {
            let realName = "";
            if (item.realName !== "" && item.realName !== undefined) {
              realName = Base64.decode(item.realName);
            } else {
              realName = item.name;
            }
            if (item.type === "Person") {
              this.userType = "0";
            }
            if (item.type === "Child") {
              this.userType = "1";
            }
            this.userInfo = realName;
            this.userId = item.name;
            if (!item.isRoaming) {
              let roaming = localStorage.getItem(this.userId);
              if (!roaming || roaming !== "1") {
                this.showRoaming = true;
              } else {
                this.showRoaming = false;
                this.userType = "2";
              }
            } else {
              this.userType = "2";
            }
            if (this.groupUserInfo === "") {
              this.groupUserInfo = "机构登录";
            }
            this.showloginOut = true;
          }
          if (item.type === "Group") {
            this.groupUserInfos.push(item);
            let realName = "";
            if (item.realName !== "" && item.realName !== undefined) {
              realName = Base64.decode(item.realName);
            } else {
              realName = item.name;
            }
            this.groupUserInfo = realName;
            this.url = process.env.VUE_APP_WEB_LOGIN_URL;
          }
        });
      })
      .catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        this.userInfo = "";
        this.showRoaming = false;
      });
  },
  mounted() {
    this.hasH5 = this.isMobile();
    const code = this.getUrlParameter(this.$route.fullPath).code;
    const state = this.getUrlParameter(this.$route.fullPath).state;
    if (code !== undefined && code !== null && code !== "") {
      // this.checkLogin(code, state);
      window.opener.postMessage({
        type: 'loginSuccess',
        code: code,
        state: state
      }, 'https://wesitrans.com');
      window.close();
      return;
    }
    this.setAdvantageList();
  },
	methods: {
	    clickCarousel(item) {
	      trackElementClick({
	        eventName: "home_carousel_click",
	        trackId: `home.carousel.${item && (item.id || item.title || item.toPath) || "unknown"}`,
	        text: item && item.title ? `点击首页轮播图：${item.title}` : "点击首页轮播图",
	        type: "banner",
	        tag: "img",
	        componentName: "NewIndexCarousel",
	        businessId: item && item.toPath || "",
	      }, {
	        trackSource: "method_carousel_before_navigate",
	      });
	      flush();
	      window.setTimeout(() => {
	        this.toConfigPath(item && item.toPath);
	      }, 120);
	    },
	    gotoPage(type) {
      if (type === "text") {
        this.toPath("/translate", "txt");
      } else if (type === "doc") {
        this.toPath("/translate", "doc");
      } else if (type === "ai") {
        this.toPath("/translate", "AITranslate");
      } else if (type === "lange") {
        this.toPath("/translate", "more");
      } else if (type === "img") {
        this.toPath("/translate", "img");
      } else if (type === "polish") {
        this.toPath("/translate", "polish");
      } else if (type === "aiPPT") {
        this.toPath("/translate", "aiPPT");
      } else if (type === "rag") {
        this.toPath("/rag");
      } else if (type === "scholar") {
        this.toPath("/scholar");
      } else if (type === "categoryTool") {
        this.toPath("/category-tool");
      } else if (type === "pro") {
        this.toPath("/trans-pro");
      }
    },
    selectTool(val) {
      this.currentTool = val;
    },
    changeAdvantageIndex(val) {
      this.advantageIndex = this.advantageIndex + val;
      this.setAdvantageList();
    },
    setAdvantageList() {
      this.advantageList = this.oriAdvantageList.slice(
        this.advantageIndex,
        this.advantageIndex + 4
      );
      console.log(555, this.advantageIndex, this.advantageList);
    },
    getCarousel() {
      let request = getCarouselRequest;
      const TOKEN_KEY = "token";
      translateServiceClient
        .getCarousel(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          const carouselList = [];
          res.getCarouselList().forEach((item) => {
            carouselList.push({
              toPath: item?.getToPath(),
              pathUrl: item?.getPathUrl(),
              title: item?.getTitle(),
            });
          });

          this.carouselList = carouselList;
          console.log(123, carouselList);
        })
        .catch((err) => {
          console.log(222, err);
        });
    },
    getActivityNotice() {
      const TOKEN_KEY = "token";
      translateServiceClient
        .getActivityNotice(getActivityNoticeRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.hasActivityNotice()) {
            this.activityNotice = null;
            this.payCenterDialogVisible2 = false;
            return;
          }
          const notice = res.getActivityNotice();
          this.activityNotice = {
            id: notice.getId(),
            title: notice.getTitle(),
            imageUrl: notice.getImageUrl(),
            linkUrl: notice.getLinkUrl(),
            startTime: notice.getStartTime(),
            endTime: notice.getEndTime(),
          };
          this.updateActivityNoticeVisibility();
        })
        .catch(() => {
          this.activityNotice = null;
          this.payCenterDialogVisible2 = false;
        });
    },
    updateActivityNoticeVisibility() {
      if (!this.activityNotice || !this.activityNotice.id) {
        this.payCenterDialogVisible2 = false;
        return;
      }
      const closedActivityId = localStorage.getItem("closedActivityNoticeId");
      this.payCenterDialogVisible2 = closedActivityId !== String(this.activityNotice.id);
    },
    //是移动端返回true,否则false
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    },
    payCenterDialogVisible2Close() {
      this.payCenterDialogVisible2 = false;
      if (this.activityNotice && this.activityNotice.id) {
        localStorage.setItem("closedActivityNoticeId", String(this.activityNotice.id));
      }
    },
    payCenterDialogVisibleClose() {
      this.payCenterDialogVisible = false;
      localStorage.setItem("payCenterDialogVisible", false);
      this.updateActivityNoticeVisibility();
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient
        .getUploadTip(uploadTipRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.isShowInRoaming = res.getIsRoaming();
          this.isShowTransPro = res.getIsTransPro();
        })
        .catch((err) => {
          this.isShowInRoaming = false;
          this.isShowTransPro = true;
        });
    },
    getQrcode() {
      this.qrcodeUrl = "https://common.wesitrans.com/common/roaming/qrcode";
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000);
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== "1") {
        let request = checkRoamingRequest;
        request.setUserId(this.userId);
        const TOKEN_KEY = "token";
        translateServiceClient
          .checkRoaming(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            localStorage.setItem(this.userId, res.getMessage());
            if (res.getMessage() === "1") {
              window.location.reload();
            }
          })
          .catch((err) => {});
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: "login-demo-class home-auth-layer",
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      } else {
        layer.open({
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      }
    },
    showTip() {
      let hasAwarded = localStorage.getItem("hasAwarded");
      if (hasAwarded !== undefined && hasAwarded !== null) {
        this.hasAwarded = false;
      }
      let payCenterDialogVisible = localStorage.getItem(
        "payCenterDialogVisible"
      );
      this.payCenterDialogVisible = !(
        payCenterDialogVisible !== undefined && payCenterDialogVisible !== null
      );
    },
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code);
      request.setState(state);
      const TOKEN_KEY = "token";
      authServiceClient
        .thirdLogin(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          let status = res.getStatus();
          if (status === "400") {
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: res.getMessage(),
            });
            setTimeout(this.toNew, 3000);
            return;
          }
          if (status === "201") {
            let openid = res.getOpenid();
            let type = res.getType();
            if (this.hasH5) {
              this.$router.push({
                name: "NewBind",
                params: { openid: openid, type: type },
              });
              return;
            }
            this.$router.push({
              name: "Bind",
              params: { openid: openid, type: type },
            });
            return;
          }
          if (status === "200") {
            this.$router.push("/index");
            // window.location.reload();
            return;
          }
        })
        .catch((err) => {
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "登录失败请重试",
          });
        });
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split("?");
      url = url[url.length - 1];
      let obj = {};
      url.split("&").map((query) => {
        let temp = query.split("=");
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    toLogin() {
      const TOKEN_KEY = "token";
      authServiceClient
        .getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.getStatus()) {
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            window.parent.postMessage(
              {
                data: "register",
              },
              "*"
            );
            return;
          }
          if (
            localStorage.getItem("auth-context") &&
            localStorage.getItem("token")
          ) {
            authServiceClient
              .checkUserPower(userPowerRequest, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                if (res.getStatus()) {
                  this.$router.push("/translate");
                  return;
                }
                this.$message({
                  center: true,
                  type: "error",
                  showClose: true,
                  duration: 3000,
                  message: res.getMessage(),
                });
                window.parent.postMessage(
                  {
                    data: "params",
                  },
                  "*"
                );
              })
              .catch((err) => {
                window.parent.postMessage(
                  {
                    data: "params",
                  },
                  "*"
                );
              });
          }
        })
        .catch((err) => {
          window.parent.postMessage(
            {
              data: "register",
            },
            "*"
          );
        });
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", "_blank");
    },
    closeAwarded() {
      this.hasAwarded = false;
      localStorage.setItem("hasAwarded", false);
    },
    toConfigPath(url) {
      window.open(url, "_self");
    },
    toPath(url, type) {
      this.showSelect = false;
      if (url === "/trans-pro") {
        window.open("/trans-pro/index", "_self");
        return;
      }
      if (url === "/list" || url === "/list-pro") {
        const TOKEN_KEY = "token";
        authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getStatus()) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              return;
            }
            if (
              localStorage.getItem("auth-context") &&
              localStorage.getItem("token")
            ) {
              authServiceClient
                .checkUserPower(userPowerRequest, {
                  [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                })
                .then((res) => {
                  if (res.getStatus()) {
                    this.$router.push(url);
                    return;
                  }
                  this.$message({
                    center: true,
                    type: "error",
                    showClose: true,
                    duration: 3000,
                    message: res.getMessage(),
                  });
                  if (this.hasH5) {
                    this.$router.push("/h5/login");
                    return;
                  }
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                })
                .catch((err) => {
                  if (this.hasH5) {
                    this.$router.push("/h5/login");
                    return;
                  }
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                });
            }
          })
          .catch((err) => {
            if (this.hasH5) {
              this.$router.push("/h5/login");
              return;
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          });
        return;
      }
      if (type) {
        this.$router.push({
          path: url,
          query: { type: type },
        });
        return;
      }
      this.$router.push({
        path: url,
      });
    },
    searchScholarFromHome() {
      const keyword = (this.scholarKeyword || "").trim();
      if (!keyword) {
        this.$message.warning("请输入文献检索关键词");
        return;
      }
      this.$router.push({
        path: "/scholar",
        query: {
          q: keyword,
        },
      });
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: "login-demo-class",
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/try", "no"],
        });
      } else {
        layer.open({
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/try", "no"],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", "_blank");
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", "_blank");
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", "_blank");
        return;
      }
      if (val === "toRoaming") {
        window.open(
          "https://common.wesitrans.com/common/roaming/roaming",
          "_blank"
        );
        return;
      }
      if (val === "txtTrans") {
        this.toPath("/translate", "txt");
        return;
      }
      if (val === "docTrans") {
        this.toPath("/translate", "doc");
        return;
      }
      if (val === "mediaTrans") {
        this.openNewMessage();
        return;
      }
      if (val === "imgTrans") {
        this.toPath("/translate", "img");
        return;
      }
      if (val === "xlsTrans") {
        this.toPath("/translate", "more");
        return;
      }
      if (val === "musicTrans") {
        this.openNewMessage();
        return;
      }

      if (val === "toTransPro") {
        this.toPath("/trans-pro");
        return;
      }
      if (val === "standLangSet") {
        this.toPath("/translate", "setting");
        return;
      }
      if (val === "convertDoc") {
        this.toPath("/translate", "convert");
        return;
      }
      if (val === "mySelfDoc") {
        this.toPath("/list-pro");
        return;
      }
      if (val === "webTranslate") {
        this.toPath("/translate", "plugin");
        return;
      }
      if (val === "smartClassify") {
        this.toPath("/smart-classify");
        return;
      }

      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo);
      } else {
        request.setName(val);
      }
      const TOKEN_KEY = "token";
      authServiceClient
        .logOut(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          window.location.reload();
          this.$router.push("/index");
        })
        .catch((err) => {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.userInfo = "";
          this.showRoaming = false;
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
        });
    },
    openNewMessage() {
      this.$alert("服务升级中，敬请期待", "产品升级", {
        confirmButtonText: "确定",
      });
    },
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>
<style lang="less" scoped>
.section_1 {
  align-items: center;
}
.text-wrapper_9 {
  background-color: #0c7dba !important;
  width: 100% !important;
  height: 90px !important;
  .paragraph_14 {
    margin-top: 20px !important;
    font-size: 14px !important;
  }
}
.box_1 {
  height: 155px !important;
  width: 100% !important;
  margin: 0 auto;
  background: linear-gradient(to bottom, #0c7dba 0 59px, #f7f8fa 59px 155px) !important;
  .box_2 {
    width: 1440px !important;
    padding: 0 20px;
  }
}
.el-carousel__item {
  background-color: #d3dce600;
}

/deep/.el-carousel__container {
  height: 441px !important;
}

.el-carousel__indicators--horizontal {
  bottom: 15px;
}

.el-carousel__indicator.is-active button {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 37px !important;
  height: 5px !important;
}

.el-carousel__indicator button {
  background-color: rgba(255, 255, 255, 0.3) !important;
  width: 37px !important;
  height: 5px !important;
}

.el-carousel__indicator button {
  opacity: 1;
  width: 30px;
  height: 5px;
  background: #cccccc;
}

.el-carousel__indicator.is-active button {
  opacity: 1;
  width: 30px;
  height: 5px;
  background: #063f95;
}

.el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-carousel__indicators--outside {
  bottom: 0px;
  text-align: center;
  position: absolute;
  transform: none;
}

.el-carousel__container {
  position: relative;
  height: 472px;
}

.el-carousel {
  width: 100%;
}

.el-carousel__item h3 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-more {
  position: relative;
  margin-left: 22px;
  width: auto !important;
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-more .thumbnail_4 {
  width: 10px;
  height: 6px;
}

.nav-more-menu {
  position: absolute;
  top: 28px;
  left: -12px;
  z-index: 20;
  display: none;
  min-width: 110px;
  padding: 8px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  color: #333;
  font-size: 14px;
}

.nav-more:hover .nav-more-menu {
  display: block;
}

.nav-more-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  padding: 0 12px;
  white-space: nowrap;
}

.nav-more-item:hover {
  background: #f5f7fa;
  color: #0c7dba;
}

.nav-more-sub {
  position: absolute;
  top: -8px;
  left: 100%;
  display: none;
  min-width: 126px;
  padding: 8px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  color: #333;
}

.nav-more-item:hover .nav-more-sub {
  display: block;
}

.nav-more-sub div {
  color: #333333 !important;
  height: 34px;
  padding: 0 14px;
  line-height: 34px;
}

.nav-more-sub div:hover {
  background: #f5f7fa;
  color: #0c7dba;
}

.scholar-home-search {
  position: relative;
  z-index: 8;
  width: 100%;
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  background: #f7f8fa;
  border-top: 1px solid rgba(220, 226, 232, 0.9);
  border-bottom: 0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.scholar-home-tip {
  width: 800px;
  max-width: calc(100% - 96px);
  color: #4f6375;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

.scholar-home-input {
  position: relative;
  z-index: 1;
  width: 800px !important;
  max-width: calc(100% - 96px);
  height: 48px;
  flex: 0 0 auto !important;
  display: flex;
  align-items: stretch;
  box-shadow: 0 8px 18px 0 rgba(31, 111, 152, 0.12);
  border-radius: 4px;
}

/deep/ .scholar-home-input.el-input-group {
  display: flex;
  align-items: stretch;
}

/deep/ .scholar-home-input .el-input__inner {
  flex: 1;
  height: 48px !important;
  line-height: 48px;
  padding-left: 36px;
  box-sizing: border-box;
  border-color: #dcdfe6;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}

/deep/ .scholar-home-input .el-input__inner:focus {
  border-color: #dcdfe6;
}

/deep/ .scholar-home-input .el-input__prefix {
  top: 0;
  height: 48px;
  display: flex;
  align-items: center;
}

/deep/ .scholar-home-input .el-input__icon {
  height: 48px;
  line-height: 48px;
}

/deep/ .scholar-home-input .el-input-group__append {
  width: 112px;
  height: 48px !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-color: transparent;
  border-left: 0;
  border-radius: 0 4px 4px 0;
  background: #0c7dba;
  vertical-align: top;
}

/deep/ .scholar-home-input .el-input-group__append .el-button {
  width: 112px;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  line-height: 48px;
}

/deep/ .scholar-home-input .el-input-group__append .el-button span {
  line-height: 48px;
}
</style>
<style src="../assets/v2/css/index/index.less" lang="less" scoped/>
<style src="../assets/v2/css/index/common.less" lang="less" scoped/>
<style lang="less" scoped>
.introduce {
  width: 100%;
  background: #f7f8fa;
  margin-top: 440px;
  .container {
    width: 1440px;
    height: 920px;
    margin: 0 auto;
    text-align: center;
    .title {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 36px;
      color: #2a2f36;
      margin-top: 48px;
    }
    .desc {
      font-size: 18px;
      color: #2a2f36;
      line-height: 27px;
      margin: 24px auto 0;
      width: 546px;
    }
    .introduce-container {
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 46px;
      .introduce-item {
        width: 448px;
        height: 316px;
        background: #ffffff;
        box-shadow: 0px 15px 24px 0px rgba(94, 94, 94, 0.09);
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        &:hover {
          background: #0c7dba;
          .introduce-icon {
            color: #fff;
          }
          .introduce-title {
            color: #fff;
          }
          .introduce-desc {
            color: #fff;
          }
          .goto {
            color: #fff;
          }
        }
        .introduce-icon {
          font-size: 52px;
          color: #0c7dba;
          margin-top: 46px;
        }
        .introduce-title {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 35px;
          margin-top: 18px;
        }
        .introduce-desc {
          font-size: 16px;
          color: #7a7c85;
          line-height: 25px;
          width: 336px;
          margin-top: 24px;
          text-indent: 36px;
          text-align: left;
        }
        .goto {
          font-weight: bold;
          font-size: 16px;
          color: #0c7dba;
          margin-top: 24px;
        }
      }
    }
  }
}
.advantage {
  width: 100%;
  // background: url("../assets/chat/index-bg2.png") no-repeat center;
  // background-size: cover;
  .container {
    width: 1440px;
    height: 625px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    .title {
      font-weight: bold;
      font-size: 32px;
      color: #2a2f36;
      margin-top: 50px;
    }
    .desc {
      font-size: 16px;
      color: #2a2f36;
      margin-top: 27px;
    }
    .advantage-container {
      width: 1440px;
      overflow: hidden;
      position: relative;
      display: flex;
      margin-top: 60px;
      gap: 55px;
      .advantage-item {
        width: 318px;
        height: 326px;
        background: #ffffff;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #d0d0d0;
        .upload {
          background: linear-gradient(#63a5c9, #0c7dba);
          span {
            color: #f0ffff;
          }
        }
        .format {
          background: linear-gradient(#996dc6, #6f429e);
          span {
            color: #e9d9fb;
          }
        }
        .template {
          background: linear-gradient(#ef7b7b, #d04548);
          span {
            color: #fcecec;
          }
        }
        .batch {
          background: linear-gradient(#f5bf48, #dfa320);
          span {
            color: #fcf4e2;
          }
        }
        .lange {
          background: linear-gradient(#3bc8d7, #0093a3);
          span {
            color: #e1f7fa;
          }
        }
        .custom {
          background: linear-gradient(#d093d7, #a35d9d);
          span {
            color: #fae1f9;
          }
        }
        .advantage-icon {
          height: 130px;
          color: #fff;
          font-size: 68px;
          span {
            margin-top: 30px;
          }
        }
        .introduce-title {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          margin-top: 35px;
        }
        .introduce-desc {
          font-size: 16px;
          color: #666666;
          width: 242px;
          margin: 30px auto 0;
        }
      }
    }
    .left {
      position: absolute;
      width: 180px;
      height: 48px;
      background: #976500;
      border-radius: 4px;
      bottom: 50px;
      left: 620px;
      font-size: 48px;
      color: #fff;
      cursor: pointer;
      span {
        vertical-align: super;
        transform: rotate(180deg);
      }
    }
    .right {
      position: absolute;
      width: 180px;
      height: 48px;
      background: #976500;
      border-radius: 4px;
      bottom: 50px;
      left: 620px;
      font-size: 48px;
      color: #fff;
      cursor: pointer;
      span {
        vertical-align: super;
      }
    }
  }
}
.tool {
  width: 100%;
  background: #f7f9fd;
  .container {
    width: 1440px;
    height: 680px;
    margin: 0 auto;
    text-align: center;
    .title {
      font-weight: bold;
      font-size: 32px;
      color: #2a2f36;
      margin-top: 60px;
    }
    .desc {
      font-size: 16px;
      color: #2a2f36;
      margin-top: 24px;
    }
    .tool-container {
      margin-top: 46px;
      .tabs {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 40px;
        .tabs-item {
          width: 300px;
          height: 90px;
          line-height: 90px;
          background: #ffffff;
          box-shadow: 0px 15px 24px 0px rgba(94, 94, 94, 0.09);
          border-radius: 6px;
          font-weight: bold;
          font-size: 24px;
          color: #0c7dba;
          cursor: pointer;
          &:hover,
          &.select {
            background: #0c7dba;
            color: #fff;
          }
          span {
            margin-right: 8px;
          }
        }
      }
      .tabs-container {
        .tabs-container-item {
          width: 1200px;
          margin: 0px auto;
          display: flex;
          justify-content: space-between;
          .left-container {
            width: 600px;
          }
          .right-container {
            width: 600px;
          }
          .experience {
            width: 176px;
            height: 44px;
            background: #cc8800;
            border-radius: 8px;
            text-align: center;
            line-height: 44px;
            cursor: pointer;
            color: #fff;
            margin-top: 20px;
            &:hover {
              background: #976500;
            }
          }
        }
        .art-container {
          .left-container {
            text-align: left;
            width: 380px;
            .title {
              font-weight: bold;
              font-size: 24px;
              color: #000000;
            }
            .tabs-container-list {
              font-size: 16px;
              color: #999999;
              line-height: 39px;
              margin-top: 30px;
              .list-item {
                .dot {
                  color: #0c7dba;
                }
              }
            }
          }
          .right-container {
            width: 540px;
            height: 360px;
            margin-top: 60px;
            background: url("../assets/v2/img/index/team.png") no-repeat center;
            background-size: contain;
          }
        }
        .lexicon-container {
          .left-container {
            width: 540px;
            height: 360px;
            margin-top: 60px;
            background: url("../assets/v2/img/index/more-two.png") no-repeat
              center;
            background-size: contain;
          }
          .right-container {
            text-align: left;
            width: 380px;
            .title {
              font-weight: bold;
              font-size: 24px;
              color: #000000;
            }
            .tabs-container-list {
              font-size: 16px;
              color: #999999;
              line-height: 39px;
              margin-top: 30px;
              .list-item {
                .dot {
                  color: #0c7dba;
                }
              }
            }
          }
        }
        .convert-container {
          .left-container {
            text-align: left;
            width: 380px;
            .title {
              font-weight: bold;
              font-size: 24px;
              color: #000000;
            }
            .tabs-container-list {
              font-size: 16px;
              color: #999999;
              line-height: 39px;
              margin-top: 30px;
              .list-item {
                .dot {
                  color: #0c7dba;
                }
              }
            }
          }
          .right-container {
            width: 540px;
            height: 360px;
            margin-top: 60px;
            background: url("../assets/v2/img/index/more-three.png") no-repeat
              center;
            background-size: contain;
          }
        }
        .document-container {
          .left-container {
            width: 540px;
            height: 360px;
            margin-top: 60px;
            background: url("../assets/v2/img/index/more-four.png") no-repeat
              center;
            background-size: contain;
          }
          .right-container {
            text-align: left;
            width: 380px;
            .title {
              font-weight: bold;
              font-size: 24px;
              color: #000000;
            }
            .tabs-container-list {
              font-size: 16px;
              color: #999999;
              line-height: 39px;
              margin-top: 30px;
              .list-item {
                .dot {
                  color: #0c7dba;
                }
              }
            }
          }
        }
      }
    }
  }
}
.partner {
  width: 100%;
  background: url("../assets/chat/index-bg1.png") no-repeat center;
  background-size: cover;

  .group_10 {
    height: 500px;
    width: 100%;
    display: flex;
    align-items: center;

    .text-wrapper_6 {
      width: 1200px;
      height: 35px;
      margin: 56px 0 0 0px;
      display: flex;
      justify-content: center;

      .text_32 {
        width: 150px;
        height: 35px;
        overflow-wrap: break-word;
        color: #fff;
        font-size: 36px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: 700;
        text-align: left;
        white-space: nowrap;
        line-height: 47px;
      }
    }
  }
  .partner-container {
    width: 1440px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-top: 80px;
    &:last-child {
      margin-top: 30px;
    }
    .partner-item {
      width: 200px;
      height: 110px;
      border-radius: 6px;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .img {
        width: 180px;
        height: 50px;
      }
      .name {
        font-size: 16px;
        color: #777777;
        line-height: 29px;
        margin-top: 10px;
      }
    }
  }
}
.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #e6e6e6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }
    }
  }

  .main-h5 {
    width: 100%;
    background: #f5f5f5;
    display: flex;
    flex-flow: column;
    align-items: center;

    .main-head {
      width: 100%;
      height: 468px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      .main-info {
        width: 768px;
        height: 386px;
        background: url("../assets/H5/bac1.png") no-repeat;
        background-position: right;
        background-size: contain;
        position: absolute;

        .main-font {
          margin-left: 30px;

          .main-info-font {
            width: 445px;
            height: 35px;
            font-size: 36px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #5e6176;
            line-height: 56px;
          }

          .main-info-font2 {
            width: 312px;
            height: 96px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #73767d;
            line-height: 36px;
            margin-top: 43px;
          }

          .main-button {
            width: 166px;
            height: 48px;
            background: #063f95;
            border-radius: 25px 0px 25px 0px;
            margin-top: 36px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 56px;
            }
          }
        }
      }
    }

    .main-top {
      width: 768px;

      .main-top-head {
        margin-top: 36px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        text-align: center;
        background: url("../assets/H5/head-font.png") no-repeat;
        background-size: 285px;
        background-position: center bottom;
      }

      .main-top-head-info {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #73767d;
        line-height: 36px;
        display: flex;
        justify-content: center;
        margin-top: 30px;

        div {
          width: 598px;
          height: 95px;
        }
      }
    }

    .main-select {
      margin-top: 57px;
      width: 768px;

      .main-select-item {
        display: flex;
        margin: 0 33px;
        justify-content: space-between;
        height: 220px;
        margin-bottom: 58px;

        .main-select-item-one {
          display: flex;
          flex-flow: column;
          width: 336px;

          .item-head {
            width: 100px;
            height: 24px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 40px;
            margin-top: 22px;
          }

          .item-info {
            width: 336px;
            height: 60px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #73767d;
            line-height: 36px;
            margin-top: 19px;
          }
        }

        .main-select-item-two {
          display: flex;
          flex-flow: column;
          width: 336px;

          .item-head {
            width: 100px;
            height: 24px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 40px;
            margin-top: 22px;
          }

          .item-info {
            width: 336px;
            height: 60px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #73767d;
            line-height: 36px;
            margin-top: 19px;
          }
        }
      }
    }

    .main-desc {
      width: 768px;

      .main-desc-tsfy {
        background: url("../assets/H5/tsfy.png") no-repeat;
        background-position: left;
        background-size: contain;
        height: 387px;
        display: flex;
        justify-content: flex-end;

        .main-desc-tsfy-right {
          display: flex;
          flex-flow: column;
          width: 260px;
          justify-content: center;
          margin-right: 20px;

          .main-desc-tsfy-right-head {
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            background: url("../assets/H5/head-font.png") no-repeat;
            background-size: 285px;
            background-position: center bottom;
            width: 125px;
          }

          .main-desc-tsfy-right-info {
            margin-top: 37px;
            margin-bottom: 37px;
            width: 260px;
            font-size: 24px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #73767d;
            line-height: 36px;
          }

          .main-desc-tsfy-right-button {
            width: 166px;
            height: 48px;
            background: #063f95;
            border-radius: 25px 0px 25px 0px;
            text-align: center;

            span {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 46px;
            }
          }
        }
      }

      .main-desc-wjzh {
        margin-top: 100px;
        background: url("../assets/H5/wjzh.png") no-repeat;
        background-position: right;
        background-size: contain;
        height: 387px;
        display: flex;
        justify-content: flex-start;

        .main-desc-tsfy-wjzh {
          display: flex;
          flex-flow: column;
          width: 260px;
          justify-content: center;
          margin-left: 33px;

          .main-desc-tsfy-wjzh-head {
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            background: url("../assets/H5/head-font.png") no-repeat;
            background-size: 285px;
            background-position: center bottom;
            width: 125px;
          }

          .main-desc-tsfy-wjzh-info {
            margin-top: 37px;
            margin-bottom: 37px;
            width: 288px;
            font-size: 24px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #73767d;
            line-height: 36px;
          }

          .main-desc-tsfy-wjzh-button {
            width: 166px;
            height: 48px;
            background: #063f95;
            border-radius: 25px 0px 25px 0px;
            text-align: center;

            span {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 46px;
            }
          }
        }
      }
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233e;
      line-height: 36px;
    }
  }
}

/deep/ .payTipClass3 {
  background-color: #f0f8ff00;
  border: 0px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
  cursor: pointer;
  width: 672px;

  .el-dialog__header {
    //display: none;
  }

  .el-dialog__body {
    margin: 0 !important;
    padding: 0 !important;
    text-align: center;
  }

  .el-dialog__footer {
    display: none;
  }
}

.user-img {
  width: 16px;
  float: right;
  padding-left: 5px;
}

.el-input {
  width: 90%;
}

.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  //background: url("../assets/img/bac6.png") #F5F5F5 no-repeat 120% top;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {
      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: #063f95;
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dddddd;
        cursor: pointer;
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(3):hover {
        background-color: #1565dc;
      }
    }
  }

  .line-hr {
    display: flex;
    width: 100%;
    height: 1px;
    background: #dddddd;
    border: 0;
  }

  .nav {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    //background: #ffffff;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

    .nav-border {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #e6e6e6;

      div {
        display: flex;
        width: 1200px;
        justify-content: flex-start;
        align-items: center;

        label {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          width: 10%;
          cursor: pointer;

          .index {
            display: flex;
            width: 40px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          div:nth-child(1):hover {
            width: 40px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(1) {
          width: 7%;
        }

        label:nth-child(2) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(3) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(4) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(5) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }
      }
    }
  }

  .top {
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: center;

    .top-one {
      width: 50%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;

      .title {
        display: flex;
        height: 153px;
        align-items: flex-end;

        span {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #5e6176;

          span {
            color: #063f95;
          }
        }
      }

      .desc {
        margin-top: 34px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-end;

        p {
          display: flex;
          width: 300px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767d;
          padding: 0;
          margin: 0;
        }

        p:nth-child(2) {
          margin-top: 5px;
        }
      }

      .login {
        margin-top: 60px;
        display: flex;

        div {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 166px;
          height: 48px;
          //background: rgba(255, 255, 255, 0);
          border-radius: 26px 0px 26px 0px;
          border: 1px solid #063f95;
          font-size: 24px;
          font-family: Source Han Sans CN;
          //color: #063F95;
          font-weight: bold;
          cursor: pointer;
          background: #063f95;
          color: white;
        }

        div:hover {
          background: #dee3e9;
          color: #063f95;
        }
      }
    }

    .top-img {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 30px;
    }
  }

  .top-par {
    display: flex;
    width: 100%;
    margin-top: 114px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      to top,
      white 0%,
      white 50%,
      #f5f5f5 51%,
      #f5f5f5 100%
    );

    .top {
      z-index: 1;
      display: flex;
      width: 1200px;
      height: 160px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px rgba(96, 96, 96, 0.35);
      border-radius: 5px;
      justify-content: center;
      align-items: center;

      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      div:nth-child(1) {
        span:nth-child(1) {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #063f95;
        }

        span:nth-child(2) {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767d;
          margin-top: 10px;
        }
      }

      div:nth-child(2) {
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        height: 114px;

        span:nth-child(1) {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #063f95;
        }

        span:nth-child(2) {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767d;
          margin-top: 10px;
        }
      }

      div:nth-child(3) {
        span:nth-child(1) {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #063f95;
        }

        span:nth-child(2) {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767d;
          margin-top: 10px;
        }
      }
    }
  }

  .why {
    padding-top: 95px;
    display: flex;
    width: 100%;
    //background: url("../assets/img/bac3.png") white 0% 40% no-repeat;
    justify-content: center;
    align-items: center;

    .why-main {
      width: 1200px;
      flex-direction: row;
      display: flex;

      .why-main-1 {
        display: flex;
        flex-direction: column;
        width: 508px;

        .why-1 {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          width: 340px;
          background: url("../assets/img/bac8.png") no-repeat left bottom;
          height: 28px;
        }

        .why-2 {
          width: 300px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767d;
          line-height: 30px;
          margin-top: 34px;
        }
      }

      .why-main-2 {
        width: 60%;
        display: flex;
        flex-direction: column;

        .why-main-child {
          display: flex;
          flex-direction: row;
          width: 100%;

          .why-child {
            margin-top: 18px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            //background: url("../assets/img/bac8.png") no-repeat left bottom;
            height: 20px;
            background-size: 65px 5px;
          }

          .why-child2 {
            margin-top: 18px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #73767d;
            line-height: 24px;
            width: 280px;
          }
        }
      }
    }
  }

  .trans {
    margin-top: 128px;
    //z-index: 1;
    display: flex;
    width: 1200px;
    justify-content: center;
    align-items: center;
    background: url("../assets/img/bac9.png") #f5f5f5 no-repeat;
    height: 385px;
    align-items: flex-start;

    div:nth-child(1) {
      display: flex;
      width: 70%;
    }

    div:nth-child(2) {
      display: flex;
      width: 30%;
      flex-direction: column;
      margin-top: 80px;

      div:nth-child(1) {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 30px;
        width: 96px;
        background: url("../assets/img/bac8.png") no-repeat left bottom;
      }

      div:nth-child(2) {
        height: 46px;
        font-size: 14px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #73767d;
        line-height: 30px;
        margin-top: 34px;
        display: flex;
        width: 80%;
      }

      div:nth-child(3) {
        margin-top: 68px;

        div {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 166px;
          height: 48px;
          //background: rgba(255, 255, 255, 0);
          border-radius: 26px 0px 26px 0px;
          border: 1px solid #063f95;
          font-size: 24px;
          font-family: Source Han Sans CN;
          //color: #063F95;
          font-weight: bold;
          cursor: pointer;
          background: #063f95;
          color: white;
        }

        div:hover {
          background: #dee3e9;
          color: #063f95;
        }
      }
    }
  }

  .convert {
    margin-top: 128px;
    margin-bottom: 95px;
    display: flex;
    width: 1200px;
    justify-content: center;
    align-items: center;
    background: url("../assets/img/bac10.png") #f5f5f500 right no-repeat;
    height: 390px;
    align-items: flex-start;

    div:nth-child(2) {
      display: flex;
      width: 70%;
    }

    div:nth-child(1) {
      display: flex;
      width: 30%;
      flex-direction: column;
      margin-top: 40px;

      div:nth-child(1) {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 30px;
        width: 96px;
        background: url("../assets/img/bac8.png") no-repeat left bottom;
      }

      div:nth-child(2) {
        height: 46px;
        font-size: 14px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #73767d;
        line-height: 30px;
        margin-top: 34px;
        display: flex;
        width: 350px;
      }

      div:nth-child(3) {
        margin-top: 68px;

        div {
          padding: 0;
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 166px;
          height: 48px;
          //background: rgba(255, 255, 255, 0);
          border-radius: 26px 0px 26px 0px;
          border: 1px solid #063f95;
          font-size: 24px;
          font-family: Source Han Sans CN;
          //color: #063F95;
          font-weight: bold;
          cursor: pointer;
          background: #063f95;
          color: white;
        }

        div:hover {
          background: #dee3e9;
          color: #063f95;
        }
      }
    }
  }

  .gg {
    margin-top: 95px;
    display: flex;
    width: 100%;
    background: #ffffff;
    justify-content: center;
  }

  .hzdw {
    width: 1200px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .foot {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dddddd;
    flex-flow: column;

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233e;
      line-height: 28px;
    }
  }
}

.nav-more {
  color: #ffffff !important;

  .nav-more-menu,
  .nav-more-sub {
    color: #333333 !important;

    span,
    div,
    i {
      width: auto !important;
      color: #333333 !important;
    }
  }

  .nav-more-item:hover,
  .nav-more-sub div:hover {
    color: #0c7dba !important;

    > span,
    > div,
    i {
      color: #0c7dba !important;
    }
  }

  .nav-more-item:hover .nav-more-sub div {
    color: #333333 !important;
  }

  .nav-more-item:hover .nav-more-sub div:hover {
    color: #0c7dba !important;
  }
}
</style>
